import { formatFixed } from "Util"

const QaisDetail = ({ data, title }) => {
  function renderingComment(step) {
    if (step === 1) {
      return (
        <div className="txt"><strong className="txt_red">매우 낮은</strong> 수준입니다</div>
      )
    } else if (step === 2) {
      return (
        <div className="txt"><strong className="txt_orange">낮은</strong> 수준입니다</div>
      )
    } else if (step === 3) {
      return (
        <div className="txt"><strong className="txt_yellow">보통</strong> 수준입니다</div>
      )
    } else if (step === 4) {
      return (
        <div className="txt"><strong className="txt_green">높은</strong> 수준입니다</div>
      )
    } else if (step === 5) {
      return (
        <div className="txt"><strong className="txt_darkgreen">매우 높은</strong> 수준입니다</div>
      )
    }

    return null
  }

  function renderingBar(step) {
    let barColor = ''

    if (step === 1) {
      barColor = 'bar_red'
    } else if (step === 2) {
      barColor = 'bar_orange'
    } else if (step === 3) {
      barColor = 'bar_yellow'
    } else if (step === 4) {
      barColor = 'bar_green'
    } else if (step === 5) {
      barColor = 'bar_darkgreen'
    }

    const result = []

    for (let i = 0; i < 5; i++) {
      result.push(
        <i key={i} className={i < step ? 'full' : ''}></i>
      )
    }

    return (
      <div className={`bar ${barColor}`}>
        {result}
      </div>
    )
  }

  function renderingScore(score, step) {
    let numColor = ''

    if (step === 1) {
      numColor = 'txt_red'
    } else if (step === 2) {
      numColor = 'txt_orange'
    } else if (step === 3) {
      numColor = 'txt_yellow'
    } else if (step === 4) {
      numColor = 'txt_green'
    } else if (step === 5) {
      numColor = 'txt_darkgreen'
    }

    return (
      <div className="rt">
        <div className={`num ${numColor}`}>{formatFixed(score, 0)}</div>
        {renderingBar(step)}
      </div>
    )
  }

  return (
    <div className="tabbox selected qais-detail-list">
      {data?.SCORE1 && data?.STEP1 ? (
        <div className="box" style={{ marginBottom: 12 }}>
          <div className="lt">
            <div className="tit">{title?.[0]}</div>
            {renderingComment(data.STEP1)}
          </div>
          {renderingScore(data.SCORE1, data.STEP1)}
        </div>
      ) : null}

      {data?.SCORE2 && data?.STEP2 ? (
        <div className="box" style={{ marginBottom: 12 }}>
          <div className="lt">
            <div className="tit">{title?.[1]}</div>
            {renderingComment(data.STEP2)}
          </div>
          {renderingScore(data.SCORE2, data.STEP2)}
        </div>
      ) : null}

      {data?.SCORE3 && data?.STEP3 ? (
        <div className="box" style={{ marginBottom: 0 }}>
          <div className="lt">
            <div className="tit">{title?.[2]}</div>
            {renderingComment(data.STEP3)}
          </div>
          {renderingScore(data.SCORE3, data.STEP3)}
        </div>
      ) : null}
    </div>
  )
}

export default QaisDetail